import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { connectToForum } from 'redux/slices/liveShow/thunks'
import { useParams } from 'react-router-dom'
import Forum from 'components/set/Forum/Forum'
import { getShow } from 'redux/slices/liveShow'
import { useAuthenticatedState } from 'libs/web-client/utils/auth0/src'
import Loader from '../set/AnimatedSetPageLoading/Loader'

const EventQA = () => {
    const { showPath } = useParams()
    const show = useSelector(getShow)
    const dispatch = useDispatch()
    const { isAuthenticated, user } = useAuthenticatedState()

    useEffect(() => {
        dispatch(connectToForum(showPath))
    }, [dispatch, showPath])

    const Wrapper = ({ children }) => (
        <div style={{ background: '#1c2029', width: '100%', height: '100%' }}>{children}</div>
    )

    return (
        (isAuthenticated && user && show && (
            <Wrapper>
                <Forum user={user} isAuthenticated={isAuthenticated} show={show} fullScreen />
            </Wrapper>
        )) || (
            <Wrapper>
                <Loader isLoading />
            </Wrapper>
        )
    )
}

export default EventQA
